<script setup lang="ts">

</script>

<template>
	<div class="layout layout--default">
		<div class="main-container">
			<div class="main-wrapper">
				<main class="main">
					<slot />
				</main>

				<HmCopyright has-help is-absolute />
			</div>
		</div>
	</div>
</template>
